import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { DealershipListOptions } from "./DealershipListOptions"
import type { GetDealershipListOptionsQueryParams } from "./GetDealershipListOptionsQueryParams"

export const getDealershipListOptionsRoute: ApiRoute<
	NoPathParams,
	GetDealershipListOptionsQueryParams,
	NoBody,
	DealershipListOptions
> = {
	buildUrl: () => "/dealerships/options",
	method: "get",
	path: "/dealerships/options",
}
